import { FormInstance, message } from 'antd'
import { ValidateErrorEntity } from 'rc-field-form/es/interface'

// 表单name转为字符串
export const stringifyName = (name: any) => {
    if (Array.isArray(name)) {
        return name.join('.')
    }
    return name
}

const whiteProperty = ['component', 'shouldRender', 'renderProps', 'renderOptions', 'shouldUpdate']

// 构建表单
export const buildFields = ({ fieldsList, fieldsMap }: any) => {
    if (!Array.isArray(fieldsList)) {
        return () => []
    }

    const arr = fieldsList
        .map(name =>
            fieldsMap.find(v => {
                const fName = stringifyName(name)
                const vName = stringifyName(v.name)

                return fName === vName
            }),
        )
        .filter(Boolean)

    return props => {
        return arr.map(v => {
            let obj = {}

            for (let p in v) {
                if (v.hasOwnProperty(p)) {
                    const t = v[p]

                    if (!whiteProperty.includes(p) && typeof t === 'function') {
                        obj[p] = t(props)
                    } else {
                        obj[p] = t
                    }

                    if (p === 'renderComponent') {
                        obj.component = t(props)
                    }
                }
            }

            return obj
        })
    }
}

export const getOptionsByEnum = (obj: any) => {
    try {
        return Object.keys(obj).map(key => ({ label: obj[key], value: key }))
    } catch (error) {
        console.error('catchError', error)
        return []
    }
}

/** 检查错误信息是否为 `ValidateErrorEntity` 类型 */
export function assertIsValidateErrorEntity(error: unknown): error is ValidateErrorEntity {
    if (!error || typeof error !== 'object') {
        return false
    }
    const { values, errorFields } = error as ValidateErrorEntity
    return values !== undefined && Array.isArray(errorFields)
}

/** 获取表单校验返回的第一个错误信息 */
export function getFormFirstErrorMessage(error: unknown): string | undefined {
    if (!assertIsValidateErrorEntity(error)) {
        return undefined
    }

    const [firstError] = error.errorFields

    if (!firstError) {
        return undefined
    }

    const { errors } = firstError

    const [firstErrorMessage] = errors
    return firstErrorMessage
}

/**
 * 验证表单字段
 *
 * 与 `form.validateFields` 的区别是：
 *
 * 1. 验证失败，会自动提取第一个错误信息并 toast 提示；
 * 2. 验证失败，不会抛出异常，而是返回 `null`；
 *
 * @param form - 表单实例
 */
export async function validateFormFields<T>(form: FormInstance<T>): Promise<T | null> {
    let values: T | null = null

    try {
        values = await form.validateFields()
    } catch (error) {
        console.error(error)

        const errorMessage = getFormFirstErrorMessage(error)

        if (message) {
            message.error(errorMessage)
        }
    }

    return values
}
